import { create } from "zustand";

type EmpreendedoraState = {
  nome: string;
  negocioId: string | null;
  perfilCompleto: boolean;
  setNome: (nome: string) => void;
  setNegocioId: (negocioId: string | null) => void;
  setPerfilCompleto: (perfilCompleto: boolean) => void;
  clearNome: () => void;
};

export const useEmpreendedoraStore = create<EmpreendedoraState>((set) => ({
  nome: "",
  negocioId: null,
  perfilCompleto: false,
  setNome: (nome) => set({ nome }),
  setNegocioId: (negocioId) => set({ negocioId }),
  setPerfilCompleto: (perfilCompleto) => set({ perfilCompleto }),
  clearNome: () => set({ nome: "" }),
}));
